import { Amount, AmountProps } from '@ui/components/Amount/Amount';
import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { Percentage, PercentageProps } from '@ui/components/Amount/Percentage';
import {
  BigIntAmount,
  BigIntAmountProps,
} from '@ui/components/BigIntAmount/BigIntAmount';
import {
  BigIntAmountUsd,
  BigIntAmountUsdProps,
} from '@ui/components/BigIntAmount/BigIntAmountUsd';
import { Text, TextProps } from '@ui/lib/park/ui/text';
import { getTokenPriceDisplayDecimals } from '@ui/utils/getTokenPriceDisplayDecimals';
import BigNumber from 'bignumber.js';

/** V2 stat cell label: 10.5px Inter, normal case, subtle */
export const StatLabel = (p: TextProps) => {
  return (
    <Text
      textStyle="v2.tableHeader"
      fontSize="10.5px"
      letterSpacing="0.01em"
      color="v2.text.subtle"
      whiteSpace="nowrap"
      {...p}
    />
  );
};

export const StatAmount = (p: AmountProps) => {
  return (
    <Amount textStyle="numbers.small" fontSize="12.5px" fontWeight="500" color="greyWhite.lightGrey2" {...p} />
  );
};
export const StatAmountUsd = (p: AmountProps) => {
  return (
    <AmountUsd textStyle="numbers.small" fontSize="12.5px" fontWeight="500" color="greyWhite.lightGrey2" {...p} />
  );
};
export const StatPrice = (p: AmountProps) => {
  const decimal = getTokenPriceDisplayDecimals(
    new BigNumber(p.value ?? 0).toNumber(),
  );

  return (
    <AmountUsd
      textStyle="numbers.small"
      fontSize="12.5px"
      fontWeight="500"
      color="greyWhite.lightGrey2"
      opts={{
        displayDecimals: decimal,
        isTrimTrailingZero: true,
      }}
      {...p}
    />
  );
};
export const StatBigIntAmount = (p: BigIntAmountProps) => {
  return (
    <BigIntAmount
      textStyle="numbers.small"
      fontSize="12.5px"
      fontWeight="500"
      color="greyWhite.lightGrey2"
      {...p}
    />
  );
};

export const StatBigIntAmountUsd = (p: BigIntAmountUsdProps) => {
  return (
    <BigIntAmountUsd
      textStyle="numbers.small"
      fontSize="12.5px"
      fontWeight="500"
      color="greyWhite.lightGrey2"
      {...p}
    />
  );
};

export const StatPercent = (p: PercentageProps) => {
  return <Percentage textStyle="numbers.small" {...p} />;
};
